export const SOCKET = 'SOCKET'
export const USER = 'USER'
export const LANG = 'LANG'
export const PAYMENT_MODE = 'PAYMENT_MODE'
export const POINT = 'POINT'
export const POINT_TICKET = 'POINT_TICKET'
export const PAYMENTS = 'PAYMENTS'
export const PASSWORD = 'PASSWORD'
export const UPLOAD_IMG_BLOBURL = 'UPLOAD_IMG_BLOBURL'
export const COUPON_STATE = 'COUPON_STATE'
export const ACCOUNTSTATUS_STATE = 'ACCOUNTSTATUS_STATE'
export const THEME = 'THEME'
export const LIKE_TEMPLATES = 'LIKE_TEMPLATES'
export const LASTVIEW_TEMPLATES = 'LASTVIEW_TEMPLATES'
export const ADMIN = 'ADMIN'
export const BLOCK_USERS = 'BLOCK_USERS'

export const MAKE_STATE = 'MAKE_STATE'
export const TEMPLATES_STATE = 'TEMPLATES_STATE'
export const MY_VIDEO_STATE = 'MY_VIDEO_STATE'
export const MY_SHORTS_STATE = 'MY_SHORTS_STATE'
export const LIKED_VIDEO_STATE = 'LIKED_VIDEO_STATE'
export const EDITOR_STATE = 'EDITOR_STATE'
export const GALLERY_STATE = 'GALLERY_STATE'
export const GALLERY_DETAIL_STATE = 'GALLERY_DETAIL_STATE'
export const USER_GALLERY_STATE = 'USER_GALLERY_STATE'
export const MY_GALLERY_STATE = 'MY_GALLERY_STATE'
export const ORDER_STATE = 'ORDER_STATE'
export const MY_PROFILE_URL_STATE = 'MY_PROFILE_URL_STATE'
export const UNREAD_NOTI_COUNT_STATE = 'UNREAD_NOTI_COUNT_STATE'
export const NOTI_AVAILABLE_STATE = 'NOTI_AVAILABLE_STATE'

export const LOGIN_POPUP_SHOW_STATE = 'LOGIN_POPUP_SHOW_STATE'
export const SIGNUP_POPUP_SHOW_STATE = 'SIGNUP_POPUP_SHOW_STATE'

export const CURRENT_PATH_STATE = 'CURRENT_PATH_STATE'

export const VIDEO09_PAYMENTS_STATE = 'VIDEO09_PAYMENTS_STATE'

export const CREDITS_STATE = 'CREDITS_STATE'
export const CREDITS_PRODUCTS_STATE = 'CREDITS_PRODUCTS_STATE'

export const WORKSPACE_CAPACITY_STATE = 'WORKSPACE_CAPACITY_STATE'

export const REDUX_ACTION = {
    USER,
    LANG,
    PAYMENT_MODE,
    POINT,
    POINT_TICKET,
    PAYMENTS,
    PASSWORD,
    UPLOAD_IMG_BLOBURL,
    COUPON_STATE,
    ACCOUNTSTATUS_STATE,
    THEME,
    LIKE_TEMPLATES,
    LASTVIEW_TEMPLATES,
    ADMIN,
    BLOCK_USERS,

    MAKE_STATE,
    TEMPLATES_STATE,
    MY_VIDEO_STATE,
    MY_SHORTS_STATE,
    LIKED_VIDEO_STATE,
    EDITOR_STATE,
    GALLERY_STATE,
    GALLERY_DETAIL_STATE,
    USER_GALLERY_STATE,
    MY_GALLERY_STATE,
    ORDER_STATE,
    MY_PROFILE_URL_STATE,
    UNREAD_NOTI_COUNT_STATE,
    NOTI_AVAILABLE_STATE,

    LOGIN_POPUP_SHOW_STATE,
    SIGNUP_POPUP_SHOW_STATE,

    CURRENT_PATH_STATE,
    
    VIDEO09_PAYMENTS_STATE,

    CREDITS_STATE,
    CREDITS_PRODUCTS_STATE,
    WORKSPACE_CAPACITY_STATE,
}

const actionGenetator = (type, value) => {
    return {
        type,
        value
    }
}

export const socketBinding = value => actionGenetator(SOCKET, value)
export const userBinding = value => actionGenetator(USER, value)
export const langChange = value => actionGenetator(LANG, value)
export const paymentModeBinding = value => actionGenetator(PAYMENT_MODE, value)
export const pointBinding = value => actionGenetator(POINT, value)
export const pointTicketBinding = value => actionGenetator(POINT_TICKET, value)
export const paymentsBinding = value => actionGenetator(PAYMENTS, value)
export const passwordBinding = value => actionGenetator(PASSWORD, value)
export const uploadImgBloburlBinding = value => actionGenetator(UPLOAD_IMG_BLOBURL, value)
export const couponBinding = value => actionGenetator(COUPON_STATE, value)
export const accountStatusBinding = value => actionGenetator(ACCOUNTSTATUS_STATE, value)
export const themeBinding = value => actionGenetator(THEME, value)
export const likeTemplatesBinding = value => actionGenetator(LIKE_TEMPLATES, value)
export const lastViewTemplatesBinding = value => actionGenetator(LASTVIEW_TEMPLATES, value)
export const adminBinding = value => actionGenetator(ADMIN, value)
export const blockUserBinding = value => actionGenetator(BLOCK_USERS, value)

export const makeStateBinding = value => actionGenetator(MAKE_STATE, value)
export const templatesStateBinding = value => actionGenetator(TEMPLATES_STATE, value)
export const myVideoStateBinding = value => actionGenetator(MY_VIDEO_STATE, value)
export const myShortsStateBinding = value => actionGenetator(MY_SHORTS_STATE, value)
export const likedVideoStateBinding = value => actionGenetator(LIKED_VIDEO_STATE, value)
export const editorStateBinding = value => actionGenetator(EDITOR_STATE, value)
export const galleryStateBinding = value => actionGenetator(GALLERY_STATE, value)
export const galleryDetailStateBinding = value => actionGenetator(GALLERY_DETAIL_STATE, value)
export const userGalleryStateBinding = value => actionGenetator(USER_GALLERY_STATE, value)
export const myGalleryStateBinding = value => actionGenetator(MY_GALLERY_STATE, value)
export const orderStateBinding = value => actionGenetator(ORDER_STATE, value)
export const myProfileURLBinding = value => actionGenetator(MY_PROFILE_URL_STATE, value)
export const unreadNotiCountBinding = value => actionGenetator(UNREAD_NOTI_COUNT_STATE, value)
export const notiAvailableBinding = value => actionGenetator(NOTI_AVAILABLE_STATE, value)

export const loginPopupShowBinding = value => actionGenetator(LOGIN_POPUP_SHOW_STATE, value)
export const signUpPopupShowBinding = value => actionGenetator(SIGNUP_POPUP_SHOW_STATE, value)

export const currentPathBinding = value => actionGenetator(CURRENT_PATH_STATE, value)

export const payemntStateBinding = value => actionGenetator(VIDEO09_PAYMENTS_STATE, value);

export const creditsStateBinding = value => actionGenetator(CREDITS_STATE, value);
export const creditsProductsStateBinding = value => actionGenetator(CREDITS_PRODUCTS_STATE, value);

export const workspaceCapacityStateBinding = value => actionGenetator(WORKSPACE_CAPACITY_STATE, value);